module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Tone.js"));
	}, "Tone");
}